import React from 'react';
import { AuthPayloadSuccess } from '../../lib/authenticate';
import { useAuthMethod } from '../../hooks/useAuth';
import { ConvertGuestPasswordlessModal } from './ConvertGuestPasswordlessModal';

import './ConvertGuestModal.scss';

export type ConvertGuestModalProps = {
  onAuth?: (authUser?: AuthPayloadSuccess) => void;
  onCloseModal?: () => void;
  show: boolean;
  title: string;
};

export const ConvertGuestModal: React.FC<ConvertGuestModalProps> = props => {
  useAuthMethod({ authLocation: 'convert_guest' });

  return <ConvertGuestPasswordlessModal {...props} />;
};
